module.exports = __webpack_public_path__ + "img/hire-me.754ca940.jpg";